<template>
  <img :src="mapUrl" />
</template>

<script>
export default {
  name: 'MapboxStaticMap',
  data() {
    return {
      mapUrl: null
    }
  },
  props: {
    markers: {
      type: Array,
      default: () => []
    },
    size: {
      type: Array,
      default: () => [500, 400]
    }
  },
  mounted() {
    const markers = this.markers.map(x => {
      return encodeURIComponent(x.icon || 'pin-s+c00') + '(' + x.lng + ',' + x.lat + ')'
    })
    this.mapUrl = 'https://api.mapbox.com/styles/v1/mapbox/light-v10/static/' + markers.join(',') + '/auto/' + this.size[0] + 'x' + this.size[1] + '?logo=false&access_token=' + this.$appConfig.maps.providers.find(x => x.name === 'Mapbox').options.accessToken
  }
}
</script>
